/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Confirm_CancelInputs */

const en_embed_captions_confirm_cancel = /** @type {(inputs: Embed_Captions_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_embed_captions_confirm_cancel = /** @type {(inputs: Embed_Captions_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_embed_captions_confirm_cancel = /** @type {(inputs: Embed_Captions_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornieren`)
};

const it_embed_captions_confirm_cancel = /** @type {(inputs: Embed_Captions_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellare`)
};

const ru_embed_captions_confirm_cancel = /** @type {(inputs: Embed_Captions_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_embed_captions_confirm_cancel = /** @type {(inputs: Embed_Captions_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const zh_cn2_embed_captions_confirm_cancel = /** @type {(inputs: Embed_Captions_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ja_embed_captions_confirm_cancel = /** @type {(inputs: Embed_Captions_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const hi_embed_captions_confirm_cancel = /** @type {(inputs: Embed_Captions_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करना`)
};

const pt_pt2_embed_captions_confirm_cancel = /** @type {(inputs: Embed_Captions_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Embed_Captions_Confirm_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_confirm_cancel = /** @type {((inputs?: Embed_Captions_Confirm_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Confirm_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_confirm_cancel(inputs)
	if (locale === "de") return de_embed_captions_confirm_cancel(inputs)
	if (locale === "it") return it_embed_captions_confirm_cancel(inputs)
	if (locale === "ru") return ru_embed_captions_confirm_cancel(inputs)
	if (locale === "es") return es_embed_captions_confirm_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_confirm_cancel(inputs)
	if (locale === "ja") return ja_embed_captions_confirm_cancel(inputs)
	if (locale === "hi") return hi_embed_captions_confirm_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_confirm_cancel(inputs)
	return en_embed_captions_confirm_cancel(inputs)
});